import { Sun, Eye, PhoneCall, Heart } from "lucide-react";
import { OriginalWords } from "./Bits";

const Section = ({ icon: Icon, title, children, original, showOriginal, testid, alert = false }) => (
  <section data-testid={testid} className={`border-t-[1.5px] border-hf-line py-5 first:border-t-0 first:pt-0 ${alert ? "-mx-6 border-l-4 border-l-hf-brick bg-hf-brick/5 px-6" : ""}`}>
    <h3 className={`mb-2 flex items-center gap-2 font-heading text-xl ${alert ? "text-hf-brick" : "text-hf-green"}`}>
      <Icon className={`h-5 w-5 ${alert ? "text-hf-brick" : "text-hf-coral"}`} /> {title}
    </h3>
    <div className="text-lg leading-relaxed text-hf-ink">{children}</div>
    {showOriginal && <div className="mt-3"><OriginalWords label="Original words">{original}</OriginalWords></div>}
  </section>
);

const List = ({ items, alert = false }) =>
  items?.length ? (
    <ul className="space-y-2">
      {items.map((x, i) => (
        <li key={i} className="flex gap-3">
          <span className={`mt-2.5 h-2 w-2 shrink-0 rounded-full ${alert ? "bg-hf-brick" : "bg-hf-green"}`} />
          <span>{x}</span>
        </li>
      ))}
    </ul>
  ) : (
    <p className="text-hf-muted">Nothing added.</p>
  );

export function BriefCard({ brief, recipient, showOriginal = false }) {
  const o = brief.output || {};
  const i = brief.inputs || {};
  return (
    <article data-testid="brief-card" className="hf-card hf-print-brief overflow-hidden">
      <p className="hf-eyebrow">Handoff Brief</p>
      <h2 className="mb-5 mt-1 font-heading text-2xl">About {recipient || "today"}</h2>
      <Section icon={Sun} title="Today" testid="brief-section-today" showOriginal={showOriginal} original={[i.today, i.normal].filter(Boolean).join("\n")}>
        <p>{o.today}</p>
        {o.normal && <p className="mt-2 text-hf-muted">{o.normal}</p>}
      </Section>
      <Section icon={Eye} title="Watch for" testid="brief-section-watch" showOriginal={showOriginal} original={i.watch} alert>
        <List items={o.watch_for} alert />
      </Section>
      <Section icon={PhoneCall} title="Who to call" testid="brief-section-call" showOriginal={showOriginal} original={i.call}>
        <List items={o.who_to_call} />
        <p className="mt-3 text-base font-semibold text-hf-brick">In an emergency, call 911 first.</p>
      </Section>
      <Section icon={Heart} title="What always helps" testid="brief-section-helps" showOriginal={showOriginal} original={i.helps}>
        <p>{o.what_helps || "Nothing added."}</p>
      </Section>
    </article>
  );
}
